import { render } from "./LivingUnitAmenitiesAssignment.vue?vue&type=template&id=f8248b30"
import script from "./LivingUnitAmenitiesAssignment.vue?vue&type=script&lang=js"
export * from "./LivingUnitAmenitiesAssignment.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__